import { apiClient } from './client';
import type {
  CreateStandaloneInvitationDto,
  StandaloneInvitation,
  UpdateStandaloneInvitationStatusDto,
} from '@/types/standalone-invitation.types';

class StandaloneInvitationService {
  async createInvitation(guestId: number, payload: CreateStandaloneInvitationDto): Promise<StandaloneInvitation> {
    const response = await apiClient.post(`/guests/${guestId}/invitations`, payload);
    return response.data.data;
  }

  async listCelebrationInvitations(celebrationId: number, guestId?: number): Promise<StandaloneInvitation[]> {
    const response = await apiClient.get(`/guests/celebrations/${celebrationId}/invitations`, {
      params: guestId ? { guest_id: guestId } : undefined,
    });
    return response.data.data || [];
  }

  async listGuestInvitations(guestId: number, celebrationId?: number): Promise<StandaloneInvitation[]> {
    const response = await apiClient.get(`/guests/${guestId}/invitations`, {
      params: celebrationId ? { celebration_id: celebrationId } : undefined,
    });
    return response.data.data || [];
  }

  async updateInvitationStatus(
    celebrationId: number,
    invitationId: number,
    payload: UpdateStandaloneInvitationStatusDto,
  ): Promise<StandaloneInvitation> {
    const response = await apiClient.patch(
      `/guests/celebrations/${celebrationId}/invitations/${invitationId}/status`,
      payload,
    );
    return response.data.data;
  }
}

export const standaloneInvitationService = new StandaloneInvitationService();
